import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const InspirationAPI = (params) => {
  return axios.get(
    `${env.HOST}/inspirasi-terkini/artikel${params}`,
    {
      headers
    }
  );
};
export default InspirationAPI;
